import * as React from 'react';
import { Button, Checkbox, MaskedInput, Select, TDeviceType, Theme, TOptionValue, UIText3 } from '@cian/ui-kit';
import * as style from './styles.css';
import { CONSENT_PERSONAL_DATA, PRIVACY_POLICY } from 'shared/landingSeller/constants/links';
import { TFormProps } from 'shared/common/types/form';
import { clsx } from 'clsx';
import { TRegion } from 'shared/common/types/regions';
import { EModalSource } from 'shared/common/types/modal';

interface IFormProps extends TFormProps {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onSelectPolygon: (value: TOptionValue) => void;
  phoneValue: string;
  onChangePhone: (value: string) => void;
  regions: TRegion[];
  isDesktop: boolean;
  isStandartTheme: boolean;
  formIsLoading: boolean;
  device: TDeviceType;
  btnIsDisabled: boolean;
  source?: EModalSource;
  marketingAgreementUrl?: string;
  isChecked: boolean;
  toggleCheckbox: () => void;
}

export const Form: React.FC<IFormProps> = ({
  onSubmit,
  onSelectPolygon,
  onChangePhone,
  phoneValue,
  isDesktop,
  isStandartTheme,
  theme,
  device,
  isModalForm,
  regions,
  formIsLoading,
  btnIsDisabled,
  source,
  title,
  marketingAgreementUrl,
  isChecked,
  toggleCheckbox,
}) => {
  const isWhiteTheme = theme === 'white';
  const messages =
    source === EModalSource.Consultation
      ? {
          title: <span>Остались вопросы? Мы готовы на них ответить</span>,
          subtitle: 'Перезвоним и поможем во всём разобраться',
          cta: 'Позвоните мне',
        }
      : {
          title: <span>Оставьте заявку на&nbsp;продажу вместе c&nbsp;Цианом</span>,
          subtitle: <span>Мы перезвоним и&nbsp;ответим на все вопросы</span>,
          cta: 'Перезвоните мне',
        };

  return (
    <div className={clsx(style['container'], style[device], style[theme], isModalForm && style['modal'])}>
      <div className={style['title']}>{title || messages.title}</div>
      <div className={style['descr']}>{messages.subtitle}</div>
      <form className={style['form']} onSubmit={e => onSubmit(e)}>
        <div className={style['input-wrapper']}>
          <MaskedInput
            value={phoneValue}
            onChange={value => onChangePhone(value)}
            lazy
            width={'100%'}
            size="M"
            name="phone"
            mask="+7 (000) 000 00-00"
            placeholder="Номер телефона"
          />
        </div>
        <div className={style['input-wrapper']}>
          <Select width={'100%'} onChange={onSelectPolygon} size="M" options={regions} placeholder="Выберите регион" />
        </div>
        <div className={style['input-wrapper']}>
          <Theme theme={isStandartTheme ? 'onOverlay' : 'light'}>
            <Button
              loading={formIsLoading}
              disabled={btnIsDisabled}
              size="M"
              theme={isStandartTheme ? 'fill_secondary' : 'fill_primary'}
              fullWidth={!isDesktop}
            >
              {messages.cta}
            </Button>
          </Theme>
        </div>
      </form>
      <div className={style['legal']}>
        {marketingAgreementUrl && (
          <div className={style['marketing']} data-name="AgreementMarketing">
            <Checkbox checked={isChecked} onChange={toggleCheckbox} dataTestId={'marketing_agreement'} />
            <UIText3 color={isWhiteTheme ? 'text-inverted-default' : 'text-secondary-default'}>
              Соглашаюсь на{' '}
              <a href={marketingAgreementUrl} className={style['link']} target="_blank" rel="noopener noreferrer">
                рассылки и звонки
              </a>
            </UIText3>
          </div>
        )}
        <div className={style['secury']}>
          <UIText3 color={isWhiteTheme ? 'text-inverted-default' : 'text-secondary-default'}>
            {`Нажимая «${messages.cta}», я даю`}{' '}
            <a href={CONSENT_PERSONAL_DATA} target="_blank" className={style['link']} rel="noreferrer">
              Согласие на обработку персональных данных
            </a>{' '}
            в соответствии с{' '}
            <a href={PRIVACY_POLICY} target="_blank" className={style['link']} rel="noreferrer">
              Политикой конфиденциальности
            </a>
          </UIText3>
        </div>
      </div>
    </div>
  );
};
